import React from "react";
import { Icon, Link, Scrollable, InlineStack, Modal, Frame, BlockStack } from "@shopify/polaris";
import { XIcon } from "@shopify/polaris-icons";
import PropTypes from "prop-types";

const Sheet = (props) => {
  const { children, isOpen, onClose, primaryAction, secondaryAction, title } = props;
  return (
    <div style={{ height: "500px" }}>
      <Frame>
        <Modal
          open={isOpen}
          onClose={onClose}
          title={title}
          primaryAction={{
            content: { ...primaryAction.content },
            onAction: { ...primaryAction.onAction },
          }}
          secondaryActions={[
            {
              content: { ...secondaryAction.content },
              onAction: { ...secondaryAction.onAction },
            },
          ]}
        >
          <Modal.Section>
            <BlockStack gap="10">
              <div className="sheetSection">
                <InlineStack>
                  <Link onClick={onClose}>
                    <Icon source={XIcon} color="skyDark" />
                  </Link>
                </InlineStack>
              </div>
              <Scrollable className="sheetScrollable">{children}</Scrollable>
            </BlockStack>
          </Modal.Section>
        </Modal>
      </Frame>
    </div>
  );
};

Sheet.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node,
  primaryAction: PropTypes.shape({
    content: PropTypes.string,
    onAction: PropTypes.func,
  }),
  secondaryAction: PropTypes.shape({
    content: PropTypes.string,
    onAction: PropTypes.func,
  }),
};

Sheet.defaultProps = {
  isOpen: false,
  onClose: () => {},
  title: "",
  children: null,
  primaryAction: {
    content: "",
    onAction: () => {},
  },
  secondaryAction: {
    content: "",
    onAction: () => {},
  },
};

export default Sheet;
